// home.js
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import config from '../../../../config/config';
import CustomList from '../Util/List/CustomList/CustomList';
import CustomListContainer from '../Util/List/CustomList/CustomListContainer';

import '../home/Home.css';

const Qualification = () => {
    const sessionSelector = useSelector((state) => {
        return state.core.session;
    });
    const friendly_url = sessionSelector.pdc_project_friendly_url;

    const dispatch = useDispatch();

    setInterval(() => {
        dispatch({
            type: 'UPDATE_SESSION',
            key: 'current_tab_filter_notifications',
            value: [5, 6]
        });
    }, 1000);

    const paths = {
        endpoint: config.endpoints.backend + 'portal/getalldocumentations'
    };

    const list = {
        labelTitle: 'Documentos de Qualificação',
        icon: 'fa-file-lines',
        canDownload: true,
        fieldToDownload: 'file',
        filter: {
            friendly_url,
            pdc_category_id: 'ad44e4d4-6797-4fff-a41c-63cd3b1f7d64'
        },
        columns: [
            {
                name: 'document_type',
                label: 'Tipo de Documento'
            },
            {
                name: 'title',
                label: 'Título'
            },
            {
                name: 'publish_date',
                label: 'Data de Publicação'
            }
        ]
    };

    return (
        <div
            className="mt-3 mr-3"
            style={{
                marginLeft: '30px'
            }}
        >
            <CustomListContainer
                canAdd={false}
                labelTitle={list.labelTitle}
                icon={list.icon}
                content={<CustomList list={{ ...list, ...paths }} />}
            />
        </div>
    );
};

export default Qualification;
